import React from 'react'
import { useTranslation } from "react-i18next";


const Contact = () => {
    const { t } = useTranslation(["home"]);

  return (
    <div>
        <section className="rSec1">
           <h1>{t("contact.h1")}</h1>
           <div className="groupImg"><img src={require("../assets/contactImg.jpg")} alt="develop" /></div>
        </section>
        <hr />
        <section className="contact-section">
          <div className="contact-info">
            <h1>{t("contact.secondh1")}</h1> 
            <div className="media-icons">
                  <a href="https://www.facebook.com/StrongITMSP" ><img src={require("../assets/icons8-facebook-circled.gif")} alt="facebook" /></a>
            </div> 
          </div>
          <div className="contact-details">
              <table className='contact-table'>
                <tbody>
                  <tr className='row'>
                    <th>{t("contact.th1")}:</th>
                    <td><a href="/">143 131e Rue Shawinigian-sud, QC G9P 4C5</a></td>
                  </tr>
                  <tr className='row'>
                    <th>{t("contact.th2")}:</th>
                    <td><a href="tel:+14387787834">438 778 7834</a>  </td>               
                  </tr>
                  <tr className='row'>
                    <th>{t("contact.th3")}:</th>
                    <td><a href="mailto:helpdesk@strongit.ca">helpdesk@strongit.ca</a></td>
                  </tr>
                  <tr className='row'>
                    <th>{t("contact.th4")}:</th>
                    <td> <a href="mailto:james@strongit.ca">james@strongit.ca</a></td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
    </div>
  )
}

export default Contact